import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { WebformComponent } from './webform.component';
import { FieldComponent } from './field/field.component';
import {
  MobiUiIconInkableComponent,
  MobiUiCheckboxComponents,
  MobiUiDatepickerComponents,
  MobiUiDropdownComponents,
  MobiUiFormComponents,
  MobiUiInputComponents,
  MobiUiPhoneInputComponents,
  MobiUiQuestionCardComponents,
  MobiUiRadioButtonComponents,
  MobiUiSplitButtonComponents,
  MobiUiSwitchComponents,
  MobiUiTextareaComponents,
  MobiUiMessagesComponents,
  MobiUiTypeaheadComponents,
  MobiUiLoadingIndicatorComponents,
  MobiUiExpanderComponents,
  MobiUiConciergeComponents,
  MobiUiCarouselComponents,
  MobiUiContactPersonComponents,
  MobiUiPopoverComponents,
  MobiUiFileInputComponent,
  MobiUiTextBlockComponent,
} from '@mobi/rwc-ui-components-ng-jslib';
import { TextComponent } from '@app/components/text/text.component';
import { ActionsComponent } from './actions/actions.component';
import { ComplianceComponent } from './compliance/compliance.component';
import { WebformIllustrationSectionComponent } from './illustration-section/illustration-section.component';
import { StepsComponent } from './steps/steps.component';
import { CalcComponent } from './calc/calc.component';
import { DseboxComponent } from './dsebox/dsebox.component';
import { GaboxComponent } from './gabox/gabox.component';
import { InfoboxComponent } from './infobox/infobox.component';
import { PdfgenerateComponent } from './pdfgenerate/pdfgenerate.component';
import { SummaryComponent } from './summary/summary.component';
import { UvgComponent as UvgCalc } from './calc/uvg/uvg.component';
import { BikeComponent as BikeCalc } from './calc/bike/bike.component';
import { CyberComponent as CyberCalc } from './calc/cyber/cyber.component';
import { UvgComponent as UvgSummary } from './summary/uvg/uvg.component';
import { BikeComponent as BikeSummary } from './summary/bike/bike.component';
import { CyberComponent as CyberSummary } from './summary/cyber/cyber.component';
import { CardComponent as CardSummary } from './summary/card/card.component';
import { LinkComponent } from './link/link.component';
import { ContainerComponent } from './container/container.component';
import { BoxComponent } from './box/box.component';
import { DetailsComponent } from './details/details.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { TeaserListComponent } from '@app/components/teaser-list/teaser-list.component';
import { AddressComponent } from '@app/components/webform/address/address.component';
import { FormsModule } from '@angular/forms';
import { HouseholdGoodsComponent as HouseholdGoodsCalc } from '@app/components/webform/calc/household-goods/household-goods.component';
import { MortgageComponent as MortgageCalc } from '@app/components/webform/calc/mortgage/mortgage.component';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { IllustrationComponent } from '@app/components/illustration/illustration.component';
import { TextsPipe } from '@app/pipes/texts.pipe';
import { RangeComponent } from '@app/components/webform/range/range.component';
import { ReplacePipe } from '@app/pipes/replace.pipe';
import { StripHtmlPipe } from '@app/pipes/strip-html.pipe';
import { CookieConsentOverlayComponent } from '@app/components/cookie-consent-overlay/cookie-consent-overlay.component';
import { FormLoginBannerComponent } from '@app/components/webform/form-login/form-login-banner.component';
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    WebformComponent,
    FieldComponent,
    StepsComponent,
    CalcComponent,
    ActionsComponent,
    DseboxComponent,
    GaboxComponent,
    InfoboxComponent,
    PdfgenerateComponent,
    SummaryComponent,
    UvgCalc,
    BikeCalc,
    CyberCalc,
    HouseholdGoodsCalc,
    MortgageCalc,
    UvgSummary,
    BikeSummary,
    CyberSummary,
    CardSummary,
    LinkComponent,
    ContainerComponent,
    DetailsComponent,
    BoxComponent,
    ConfirmationComponent,
    AddressComponent,
    RangeComponent,
    ComplianceComponent,
    WebformIllustrationSectionComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MobiUiIconInkableComponent,
    ComponentSharedModule,
    MobiUiCheckboxComponents,
    MobiUiDatepickerComponents,
    MobiUiDropdownComponents,
    MobiUiInputComponents,
    MobiUiRadioButtonComponents,
    MobiUiSwitchComponents,
    MobiUiTextareaComponents,
    MobiUiFormComponents,
    MobiUiSplitButtonComponents,
    MobiUiQuestionCardComponents,
    MobiUiPhoneInputComponents,
    TextComponent,
    MobiUiMessagesComponents,
    MobiUiLoadingIndicatorComponents,
    MobiUiTypeaheadComponents,
    MobiUiExpanderComponents,
    MobiUiIconComponent,
    MobiUiConciergeComponents,
    IllustrationComponent,
    MobiUiCarouselComponents,
    MobiUiContactPersonComponents,
    TeaserListComponent,
    MobiUiPopoverComponents,
    BreadcrumbComponent,
    TextsPipe,
    ReplacePipe,
    StripHtmlPipe,
    MobiUiFileInputComponent,
    CookieConsentOverlayComponent,
    FormLoginBannerComponent,
    MobiUiTextBlockComponent,
  ],
  exports: [
    FormsModule,
    WebformComponent,
    MobiUiIconInkableComponent,
    ComponentSharedModule,
    MobiUiCheckboxComponents,
    MobiUiDatepickerComponents,
    MobiUiDropdownComponents,
    MobiUiInputComponents,
    MobiUiRadioButtonComponents,
    MobiUiSwitchComponents,
    MobiUiTextareaComponents,
    MobiUiFormComponents,
    MobiUiSplitButtonComponents,
    MobiUiQuestionCardComponents,
    MobiUiPhoneInputComponents,
    TextComponent,
    MobiUiLoadingIndicatorComponents,
    MobiUiTypeaheadComponents,
    MobiUiIconComponent,
    MobiUiConciergeComponents,
    MobiUiCarouselComponents,
    MobiUiContactPersonComponents,
    TeaserListComponent,
    AddressComponent,
    MobiUiPopoverComponents,
    StripHtmlPipe,
    MobiUiFileInputComponent,
    CookieConsentOverlayComponent,
    MobiUiTextBlockComponent,
  ],
})
export class WebformModule {}
